import React from 'react';
import styled from '@emotion/styled';
import isPropValid from '@emotion/is-prop-valid';
import { LazyCardImage } from 'components/common/ui/CardImage';

// Highly dynamic styles - removed from Emotion components to improve performance
export interface Box {
  width: number;
  height: number;
  x: number;
  y: number;
}

export interface ClipRatio {
  wRatio: number;
  hRatio: number;
}

export const getLayersStyles = (
  box: Box | null,
  clipRatio: ClipRatio
): React.CSSProperties | undefined => {
  if (box && clipRatio) {
    return {
      width: `${box.width * clipRatio.wRatio}px`,
      height: `${box.height * clipRatio.hRatio}px`,
    };
  }
  return undefined;
};

export const getPhotoLayerStyles = (
  box: Box,
  transparentBox: Box | null,
  clipRatio: ClipRatio
): React.CSSProperties | undefined => {
  if (box && transparentBox && clipRatio) {
    return {
      left: `${box.x - transparentBox.width * (1 - clipRatio.wRatio)}px`,
      top: `${box.y - transparentBox.height * (1 - clipRatio.hRatio)}px`,
      width: `${box.width}px`,
      height: `${box.height}px`,
    };
  }
  return undefined;
};

export const getTransparentLayerStyles = (
  box: Box | null,
  clipRatio: ClipRatio
): React.CSSProperties | undefined => {
  if (box && clipRatio) {
    return {
      left: `${box.x - box.width * (1 - clipRatio.wRatio)}px`,
      top: `${box.y - box.height * (1 - clipRatio.hRatio)}px`,
      width: `${box.width}px`,
      height: `${box.height}px`,
      minWidth: `${box.width}px`,
      minHeight: `${box.height}px`,
    };
  }
  return undefined;
};

interface Props {
  noShadow?: boolean;
}

export const Box = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin: auto;

  &::after {
    content: '';
    display: block;
    padding-bottom: 100%;
  }
`;

export const Layers = styled('div', {
  shouldForwardProp: isPropValid,
})`
  align-self: center;
  display: flex;
  justify-self: center;
  margin: auto;
  position: relative;
  ${({ noShadow }: Props) => !noShadow && 'box-shadow: 0px 0px 4px 2px rgb(0 0 0 / 30%);'}
  overflow: hidden;
`;

export const PhotoLayer = styled.img`
  position: absolute;
`;

export const TransparentLayer = styled(LazyCardImage)`
  position: absolute;
`;
